module.exports = __webpack_public_path__ + "media/img/event/profiling-result-3-5b464a7ebdc60cc0bfd782dd8b82e05a.png";